module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": _vm.savePDF
    }
  }, [_vm._v("Save PDF")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('h2', [_vm._v("Export survey to a PDF document")]), _vm._v(" "), _c('p', [_vm._v("\n      The SurveyJS PDF Export library allows you to render SurveyJS Library surveys to PDF in\n      a browser which can be later emailed or printed.\n    ")]), _vm._v(" "), _c('p', [_vm._v("Click the button below to get a PDF document.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f8d0d30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ExportToPDF.vue
// module id = 373
// module chunks = 1